import { MA_TYPE, PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "./priceSources";
import { fillMovingAverage } from "./movingAverages";

/**
 * MACD line as TV MACD: the fast EMA of the close minus the slow one
 * (MACD, OsMA, Schaff Trend Cycle). The EMAs are kept in their own arrays
 * so a tick calculates only the last values again.
 *
 * @param {object} params
 * @param {object[]} params.bars
 * @param {number} params.fastPeriod
 * @param {number} params.slowPeriod
 * @param {{ fastEma: number[], slowEma: number[] }} params.averages - values before `fromIndex` stay
 * @param {number[]} params.target - the MACD line
 * @param {number} params.fromIndex
 */
export const fillMacdLine = ({ bars, fastPeriod, slowPeriod, averages, target, fromIndex }) => {
  const read = priceReader(bars, PRICE_SOURCE.CLOSE);
  const range = { read, fromIndex, toIndex: bars.length };

  fillMovingAverage({ ...range, type: MA_TYPE.EMA, target: averages.fastEma, period: fastPeriod });
  fillMovingAverage({ ...range, type: MA_TYPE.EMA, target: averages.slowEma, period: slowPeriod });

  for (let index = fromIndex; index < bars.length; index += 1) {
    target[index] = averages.fastEma[index] - averages.slowEma[index];
  }
};
